export enum Features {
    Template = 'template',
    Zapier = 'zapier',
    DcfSpot = 'dcf_spot',
}
